import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/site/ProductCard";
import { Reveal } from "@/components/site/Reveal";

export function Trending() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { featured: true } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data.slice(0, 8) : []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  return (
    <section className="bg-[var(--ink)] text-[var(--bone)]" data-testid="trending-section">
      <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
        <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="eyebrow text-[var(--terra)]">Trending right now</p>
            <h2 className="font-display mt-4 text-4xl leading-[1.02] tracking-tight md:text-6xl">The <span className="italic text-[var(--terra)]">sold-out-twice</span> list.</h2>
          </div>
          <Link to="/shop" className="link-u self-start text-sm font-semibold md:self-auto" data-testid="trending-view-all-link">View all products →</Link>
        </Reveal>
        <div className="grid grid-cols-2 gap-x-4 gap-y-12 md:gap-x-6 lg:grid-cols-4">
          {items.map((p, i) => <ProductCard key={p.id} p={p} dark index={i} />)}
        </div>
      </div>
    </section>
  );
}
